export const defaultTabsConfig = () => {
    return {
        afterActive: function($activeItem, $visibleCard, $tabs) {
            const $slick = $visibleCard.find('.slick-slider');
            const $grid = $visibleCard.find('[data-rwd]');
            const $scroller = $visibleCard.find('.ci-scroller');
    
            if ($slick.length) {
                $slick.slick('refresh');
            }
    
            if ($grid.length) {
                $grid.trigger('icube.module.grid.resize');
            }
    
            if ($scroller.length) {
                $scroller.trigger('icube.scroller.resize');
            }
        },
        onResize: function($tabsNav, $tabs, isOverflowing) {
            if ($tabs.hasClass('is-template-2')) {
                if (isOverflowing) {
                    $tabsNav.addClass('has-content-to-left-side');
                } else {
                    $tabsNav.removeClass('has-content-to-left-side');
                }
                
            }
        }
    }
}